import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { ThemeProvider } from '@emotion/react';
import MuiMenuItem from '@mui/material/MenuItem';
import menuItemTheme from './MenuItem.theme.js';
import { useThemeExtension } from '../ThemeExtension/index.js';

/**
 * https://mui.com/api/menu-item/
 */
const MenuItem = (_a) => {
    var { children, dataAnalytics = '', dataE2e = '' } = _a, props = __rest(_a, ["children", "dataAnalytics", "dataE2e"]);
    const extendedTheme = useThemeExtension();
    return (jsx(ThemeProvider, Object.assign({ theme: (extendedTheme === null || extendedTheme === void 0 ? void 0 : extendedTheme.MenuItem) || menuItemTheme }, { children: jsx(MuiMenuItem, Object.assign({ "data-analytics": dataAnalytics, "data-e2e": dataE2e }, props, { children: children })) })));
};

export { MenuItem as default };
//# sourceMappingURL=MenuItem.js.map
